<template>
  <div style="padding:.1rem;width:100%;box-sizing: border-box;">
    <div class='seachBox'>
      <div class="seachIn">
        <div class="seaIcon">
          <img src="../../assets/img/seachIcon.png" alt="">
        </div>
        <cube-input
          v-model="value"
          placeholder="请输入关键字"
          :autofocus="true"
          ref='tempFocus'
        ></cube-input>
      </div>
      <cube-button @click='seachBtn'>搜索</cube-button>
    </div>
    <div class="noData" v-show='noDataFlag'>
      <p>没有找到您输入的位置</p>
      <p>换个关键词试试吧</p>
    </div>
    <!-- <div class="hisCon" v-show="(hisFlag||!value)&&!noDataFlag">
      <cube-tab-bar
        v-model="selectedTab"
        :data="tabs"
        :showSlider='true'
        @change="changeHandler">
      </cube-tab-bar>
      <div class='tabCon'>
        <ul>
          <li v-for='(item,index) in hisCoList' :key='index' @click="toFastRoad(item)">
            <div class='dingIcon'>
              <img src="../../assets/img/dingwei.png" alt="">
            </div>
            <div class='dingCon'>
              {{item.name}}
            </div>
          </li>
        </ul>
      </div>
    </div> -->
    <div class='seaCon' v-show='!hisFlag&&!noDataFlag'>
      <ul>
        <li v-for='(item,index) in seaResList' :key='index' @click="toThisAdd(item)">
          <div class="disF">
            <div class='dingIcon'>
              <img src="../../assets/img/dingwei.png" alt="">
            </div>
            <div class='dingCon'>
              {{item.name}}
            </div>
          </div>
          <div class="allLoc">
            <div class="ovH">{{item.address}}</div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  data() {
    return {
      useruuid: '',
      value: "",
      selectedTab: 1,
      tabs: [
        {
          label: "历史记录",
          value: 1
        },
        {
          label: "我的收藏",
          value: 2
        }
      ],
      hisFlag: true,
      seaResList: [],
      hisCoList: [],
      hisList: [],
      coList: [],
      noDataFlag:false
    };
  },
  watch: {
    value(val) {
      if (!val) {
        this.hisFlag = true;
        this.noDataFlag = false
      }
    }
  },
  mounted() {
    this.getHis();
    this.$nextTick(() => {
       this.$refs.tempFocus.focus();
    })
  },
  methods: {
    getHis() {
      this.$Post(
        "highwayInfoSVGWeb/fetchHistoryAndFavorite",
        {
          useruuid: this.useruuid
        },
        ({ data }) => {
          this.hisList = data.history;
          this.coList = data.favorite;
          this.hisCoList = this.hisList;
        },
        err => {
          this.$alertShow(err.msg);
        },
        true
      );
    },
    seachBtn() {
      if (this.value) {
        this.hisFlag = false;
        AMap.plugin("AMap.PlaceSearch", () => {
          //回调函数
          //实例化PlaceSearch
          let placeSearch = new AMap.PlaceSearch({
            pageSize: 5, //每页显示多少行
            pageIndex: 1, //显示的下标从那个开始
            type: "", //类别，可以以|后面加其他类
            city: "辽宁", //城市
            citylimit: true
          });
          //TODO: 使用placeSearch对象调用关键字搜索的功能
          placeSearch.search(this.value, (status, result) => {
            console.log(status, result)
            if (status == "no_data") {
              this.noDataFlag = true
            } else {
              this.noDataFlag = false
              this.seaResList = result.poiList.pois;
            }
          });
        });
      } else {
        this.toast = this.$createToast({
          txt: "请输入关键字",
          type: "txt"
        });
        this.toast.show();
        setTimeout(() => {
          this.toast.hide();
        }, 1000);
      }
    },
    changeHandler() {
      if (this.selectedTab == 1) {
        this.hisCoList = this.hisList;
      } else {
        this.hisCoList = this.coList;
      }
    },
    toThisAdd(obj) {
      this.$router.replace(`/fastChoose`);
      sessionStorage.setItem(
        "chooseObj",
        JSON.stringify({
          lat: obj.location.lat,
          lng: obj.location.lng,
          address: obj.address,
          addName: obj.name
        })
      );
    },
    toFastRoad(obj) {
      this.$router.push(`/fastChoose`);
      sessionStorage.setItem(
        "chooseObj",
        JSON.stringify({
          lat: obj.coor_y,
          lng: obj.coor_x,
          address: obj.address,
          addName: obj.name
        })
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
/deep/ .cube-tab_active {
  color: #199ef4;
}
/deep/ .cube-tab-bar-slider {
  background-color: #199ef4;
}
/deep/ .cube-tab-bar {
  padding: .13rem;
}
.seachBox {
  display: flex;
  height: .38rem;
  .seachIn {
    display: flex;
    width: 3rem;
    align-items: center;
    padding: .1rem .12rem;
    background-color: #eeeeee;
    border-radius: .03rem;
    .seaIcon {
      width: 10%;
      img {
        width: .18rem;
        height: .18rem;
      }
    }
    .cube-input {
      width: 80%;
      font-size: .15rem;
      background-color: inherit;
    }
    /deep/ .cube-input:after {
      border: none;
    }
    /deep/ .cube-input-field {
      padding: 0;
    }
  }
  .cube-btn {
    width: .6rem;
    margin-left: .1rem;
    padding: 0;
    background-color: #38abf5;
    font-size: .15rem;
  }
}
.noData {
  font-size: .15rem;
  text-align: center;
  margin-top: 40%;
  p {
    line-height: 1.5;
  }
}
.hisCon {
  .tabCon {
    margin-top: .1rem;
    font-size: .14rem;
    ul {
      li {
        display: flex;
        align-items: center;
        .dingIcon {
          width: .14rem;
          height: .14rem;
          margin: 0 .12rem;
        }
        .dingCon {
          border-bottom: .01rem solid #f0efef;
          padding: .1rem;
          flex: 10;
        }
      }
    }
  }
}
.seaCon {
  margin-top: .1rem;
  font-size: .14rem;
  ul {
    li {
      .disF {
        display: flex;
        align-items: center;
        font-size: .14rem;
        .dingIcon {
          width: .14rem;
          height: .14rem;
          margin-right: .1rem;
        }
        .dingCon {
          padding: .1rem 0;
          flex: 10;
        }
      }
      .allLoc {
        margin-left: .24rem;
        font-size: .12rem;
        display: flex;
        justify-content: space-between;
        color: #999999;
        padding-bottom: .06rem;
        border-bottom: .01rem solid #f0efef;
        .ovH {
          width: 90%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/fastChoose/chooseLoc.vue